import { CardHeader, CardBody, CardFooter, Body } from '@panwds/react-ui'
import type { VFC } from 'react'
import { ActivationError } from '../assets'
import { Card } from '@panwds/react-ui'
import ScreenFooter from './common/ScreenFooter'

export type DefaultErrorScreenProps = {
  title: string
  errorMessage: string
  helperMessage?: string
  linkName?: string
  linkSrc?: string
}
const DefaultErrorScreen: VFC<DefaultErrorScreenProps> = ({ errorMessage, title, linkName, linkSrc }) => { // TODO: images, title, body and buttons should come from activation manifest
  return <div className='cm-px-20 cm-py-10 tw-bg-gray-200 dark:tw-bg-blue-steel-900 cm-fixed cm-top-0 cm-left-0 cm-right-0 cm-bottom-0 cm-z-[2000]'>
    <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full'>
      <div className='tw-grid tw-col-span-1 tw-justify-center tw-m-auto cm-min-h-[520px]'>
        <Card>
          <CardHeader title={title} appearance="striped" level={2}/>
          <CardBody addClassName='tw-p-8 tw-text-center'>
            <div className='tw-text-center tw-p-8'>
              <img src={ActivationError} alt='welcome' className='cm-w-[150px]'/>
            </div>
            <Body appearance={'secondary'} addClassName='tw-mb-8'>{errorMessage}</Body>
          </CardBody>
          {linkName && linkSrc && <CardFooter>
            <a className="tw-text-link dark:tw-text-dark-bg-link" target="_blank" rel="noreferrer noopener" href={linkSrc} >{linkName}</a>
          </CardFooter>}
        </Card>
      </div>
      <ScreenFooter />
    </div>
  </div>

}

export default DefaultErrorScreen
